import React, { useCallback, useEffect, useState } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { useForm, SubmitHandler } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import api from "../../../../../../services/api";
import SyncLoader from "react-spinners/SyncLoader";
import { useRoutes } from "../../../../../../hooks/routes";

import IHookForm from "../../../../../../shared/dtos/IHookForm";
import IFormEditClauseCategory from "./dtos/IFormEditClauseCategory";

import MasterAsideControls from "../../../../components/SidebarMaster/MasterAsideControls";
import HeaderMaster from "../../../../components/SidebarMaster/HeaderMaster";
import MasterContainer from "../../../../components/SidebarMaster/MasterContainer";
import MasterMain from "../../../../components/SidebarMaster/MasterMain";

import Button from "../../../../../../shared/components/Button";
import ButtonCancel from "../../../../../../shared/components/ButtonCancel";
import Input from "../../../../../../shared/components/Input";

import { Notify } from "../../../../../../shared/utils";

import { Main, Form, ContainerInput, LabelInput, ErrorInput } from "./styles";

const EditClauseCategory: React.FC = () => {
  const [loading, setLoading] = useState(false);

  const { getUrl } = useRoutes();

  const location = useLocation();
  const dataLocation: any = location.state;

  const { clause_category_id } = useParams();

  const formSchema = yup.object().shape({
    title: yup.string().required("Título é um campo obrigatório"),
    description: yup.string().nullable(),
  });

  useEffect(() => {
    getUrl("/edit-clause-category/:clause_category_id");
  }, []);

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm<IHookForm>({
    mode: "onChange",
    resolver: yupResolver(formSchema),
  });

  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      const listClauseSpecific = await api.get(
        `/bits-clause-categories/${clause_category_id}`
      );

      reset({
        title: listClauseSpecific.data.title,
        description: listClauseSpecific.data.description
          ? listClauseSpecific.data.description
          : "",
      });
    })();
  }, [clause_category_id, reset]);

  const onSubmit: SubmitHandler<IFormEditClauseCategory> = useCallback(
    async (formData) => {
      try {
        setLoading(true);

        const updateClauseCategory = await api.put("/bits-clause-categories", {
          bits_clause_category_id: clause_category_id,
          title: formData.title,
          description:
            formData.description === "" ? undefined : formData.description,
        });

        if (updateClauseCategory.status === 200) {
          Notify({
            text: "Categoria de cláusulas atualizada com sucesso",
            type: "success",
          });
          setLoading(false);
          navigate("/clause-category", {
            state: { params: dataLocation?.params },
          });
        }
      } catch (err: any) {
        console.log(err?.response?.data);
        setLoading(false);
      }
    },
    [clause_category_id, navigate, dataLocation]
  );

  return (
    <MasterContainer>
      <MasterAsideControls />
      <HeaderMaster namePage="Editar categoria de cláusulas" />
      <MasterMain>
        <Main>
          <Form onSubmit={handleSubmit(onSubmit)}>
            <ContainerInput>
              <LabelInput>Título *</LabelInput>
              <Input
                label="title"
                register={register}
                required={true}
                placeholder="Digite o título"
              />
              {errors.title && <ErrorInput>{errors.title.message}</ErrorInput>}
            </ContainerInput>

            <ContainerInput>
              <LabelInput>Descrição</LabelInput>
              <Input
                label="description"
                register={register}
                required={false}
                placeholder="Digite a descrição"
              />
              {errors.description && (
                <ErrorInput>{errors.description.message}</ErrorInput>
              )}
            </ContainerInput>

            <ButtonCancel
              onClick={() => {
                navigate("/clause-category", {
                  state: { params: dataLocation?.params },
                });
              }}
              type="button"
              style={{ marginTop: 30, marginRight: 10 }}
              disabled={loading}
            >
              Cancelar
            </ButtonCancel>

            {!loading && (
              <Button type="submit" style={{ marginTop: 30 }}>
                Salvar
              </Button>
            )}

            {loading && (
              <Button type="submit" style={{ marginTop: 30 }} disabled={true}>
                <SyncLoader
                  loading={loading}
                  color="#ffffff"
                  size={5}
                  style={{ marginLeft: 30, marginRight: 30 }}
                />
              </Button>
            )}
          </Form>
        </Main>
      </MasterMain>
    </MasterContainer>
  );
};

export default EditClauseCategory;
